<template>
  <div class="order-description c:row-start">
    <span class="order-description-label">{{ label }}</span>
    <div
      v-if="editable"
      class="order-description-modifier c:row-start-center"
      @click="throttledOnEditClick"
    >
      <img src="@/assets/icons/edit.svg" alt="" /><span>修改</span>
    </div>
    <div
      v-if="type === 'images'"
      class="order-description-value images c:row-end-center c:flex-wrap"
    >
      <div
        v-for="(src, index) in images"
        :key="index"
        class="order-description-image"
        @click="throttledOnPreviewClick(index)"
      >
        <img :src="src" alt="" />
      </div>
    </div>
    <span v-else class="order-description-value">{{ computedValue }}</span>
    <span
      v-if="copiable"
      class="order-description-tail c:row-end-center"
      v-clipboard:copy="value"
      v-clipboard:success="onCopy"
    >
      <img src="@/assets/icons/copy-dark.svg" alt="" />
    </span>
  </div>
</template>

<script>
import { fileRead } from "@/api";
import { outputmoney, throttle } from "@/utils";
import { ImagePreview } from "vant";

export default {
  props: {
    type: {
      type: String,
      default: "text",
    },
    label: {
      type: String,
      default: "",
    },
    value: {
      type: [String, Number],
      default: "",
    },
    timeFormat: {
      type: String,
      default: "YYYY-MM-DD HH:mm:ss",
    },
    copiable: {
      type: Boolean,
      default: false,
    },
    editable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return { images: [] };
  },
  computed: {
    computedValue() {
      switch (this.type) {
        case "images":
          return ``;

        case "amount":
          return `¥ ${outputmoney(this.value)}`;

        case "time":
          return this.$moment(this.value).format(
            this.timeFormat || "YYYY-MM-DD HH:mm:ss"
          );

        default:
          return this.value;
      }
    },
  },
  watch: {
    type() {
      this.formatImagesIfNeed();
    },
    value() {
      this.formatImagesIfNeed();
    },
  },
  mounted() {
    this.formatImagesIfNeed();
  },
  created() {
    this.throttledOnEditClick = throttle(() => this.$emit("edit"), 500);
    this.throttledOnPreviewClick = throttle(this.preview, 500);
  },
  methods: {
    async formatImagesIfNeed() {
      if (this.type === "images" && this.value) {
        console.log("formatImagesIfNeed", this.type, this.value);
        try {
          this.images = (
            await Promise.all(
              JSON.parse(this.value).map((filename) =>
                fileRead(filename)
                  .then((blob) => URL.createObjectURL(blob))
                  .catch(() => undefined)
              )
            )
          ).filter((url) => url);
        } catch (error) {
          console.log("formatImagesIfNeed error", error);
          this.images = [];
        }
      }
    },
    onCopy() {
      this.$toast("复制成功");
    },
    preview(index) {
      ImagePreview(this.images, index);
    },
  },
};
</script>

<style lang="less" scoped>
.order-description {
  gap: 6/20rem;

  min-height: 11/20rem;
  line-height: 11/20rem;
  font-size: 11/20rem;
  font-weight: 400;
  letter-spacing: 0;
  color: #7d7d7d;

  &-label {
    min-width: 60/20rem;
    text-align: left;
  }

  &-modifier {
    gap: 6/20rem;
    color: #333;
  }

  &-value {
    flex: 1;
    width: 0;
    text-align: right;
  }

  &-value.images {
    gap: 6/20rem;

    .order-description-image {
      width: 50/20rem;
      height: 50/20rem;
      background-color: #fff;
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
  }

  &-tail {
    img {
      width: 12/20rem;
      height: 12/20rem;
    }
  }
}
</style>
